import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { $ } from 'react-jquery-plugin';
import AuthService from '../../../api/services/AuthService';
import { ApiConfig } from '../../../api/apiConfig/apiConfig';
import LoaderHelper from '../../../customComponents/Loading/LoaderHelper';
import { alertErrorMessage, alertSuccessMessage } from '../../../customComponents/CustomAlertMessage';
import { mapCoboWithdrawalItem } from '../../../utils/coboWithdrawal';

const WithdrawHistory = () => {
  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const [allCoinData, setAllCoinData] = useState([]);
  const [modalData, setModalData] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDataLength, setTotalDataLength] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;

  const shortenAddress = (address, length = 4) => {
    if (!address || address.length < 10) return address;
    return `${address.slice(0, length + 2)}...${address.slice(-length)}`;
  };

  const copytext = (data) => {
    navigator.clipboard.writeText(data);
    alertSuccessMessage('Copied!!');
  };

  const filteredHistory = (withdrawHistory ?? []).filter((item) => {
    if (!searchQuery?.trim()) return true;
    const q = searchQuery.trim().toUpperCase();
    return (
      item?.short_name?.toUpperCase().includes(q) ||
      item?.currency?.toUpperCase().includes(q) ||
      item?.chain?.toUpperCase().includes(q) ||
      item?.chainId?.toUpperCase().includes(q) ||
      item?.transaction_hash?.toUpperCase().includes(q) ||
      item?.to_address?.toUpperCase().includes(q)
    );
  });

  const fetchWithdrawHistory = async (page = 1) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getCoboWithdrawalHistory(page, limit);
      if (result?.success) {
        const list = (Array.isArray(result?.data) ? result.data : []).map(mapCoboWithdrawalItem);
        setCurrentPage(page);
        setWithdrawHistory(list);
        const pagination = result?.pagination || {};
        setTotalDataLength(pagination.total ?? list.length);
        setTotalPages(pagination.totalPages ?? 1);
      } else {
        alertErrorMessage(result?.message || 'Failed to load withdrawal history');
      }
    } catch (error) {
      alertErrorMessage('Failed to load withdrawal history');
    } finally {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handlePagination = (action) => {
    if (action === 'prev' && currentPage > 1) fetchWithdrawHistory(currentPage - 1);
    else if (action === 'next' && currentPage < totalPages) fetchWithdrawHistory(currentPage + 1);
    else if (action === 'first') fetchWithdrawHistory(1);
    else if (action === 'last') fetchWithdrawHistory(totalPages);
  };

  const handleWithdrawModal = (item) => {
    const mapped = mapCoboWithdrawalItem(item);
    setModalData({
      ...mapped,
      shortAddress: shortenAddress(mapped?.from_address),
      shortToAddress: shortenAddress(mapped?.to_address),
      shortTxHash: shortenAddress(mapped?.transaction_hash),
    });
    $('#recent_table').modal('show');
  };

  const allCoins = async () => {
    const result = await AuthService.allCoins();
    if (result?.success) {
      setAllCoinData(result?.data || []);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    fetchWithdrawHistory(1);
    allCoins();
  }, []);

  const CopyIcon = () => (
    <svg className="bn-svg icon-small-pointer" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ width: 18, height: 18, cursor: 'pointer', flexShrink: 0 }}>
      <path fillRule="evenodd" clipRule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor" />
    </svg>
  );

  const noDataRow = (
    <tr className="no-data-row2">
      <td colSpan="12">
        <div className="no-data-wrapper">
          <div className="no_data_vector">
            <img src="/images/no_data_vector.svg" className="img-fluid dark_img" width="96" height="96" alt="No data" />
            <img src="/images/no_data_vector_light.png" className="img-fluid light_img" alt="No data" />
          </div>
        </div>
      </td>
    </tr>
  );

  return (
    <div className="dashboard_right">
      <div className="recent_deposit_list">
        <div className="top_heading">
          <h4>Withdrawal History</h4>
          <div className="searchBar custom-tabs">
            <i className="ri-search-2-line"></i>
            <input
              type="search"
              className="custom_search"
              placeholder="Search coin, network, address, tx"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        <div className="table_outer">
          <div className="withdraw_history_desktop">
            <div className="table-responsive">
              <table>
                <tbody>
                  {filteredHistory?.length > 0 ? filteredHistory.map((item) => {
                    const shortAddress = shortenAddress(item?.to_address);
                    const shortTxHash = shortenAddress(item?.transaction_hash);
                    const filteredImageData = allCoinData?.filter((data) => data?.short_name === item?.short_name)[0] || [];
                    return (
                      <tr key={item?._id || item?.createdAt}>
                        <td>
                          <div className="td_first">
                            <div className="price_heading">
                              <img width="30px" src={Object.keys(filteredImageData).length > 0 ? ApiConfig.baseImage + filteredImageData.icon_path : ''} alt="icon" />
                              {item?.amount} {item?.currency}{' '}
                              <span className={`text-${item?.status === 'REJECTED' ? 'danger' : item?.status === 'COMPLETED' ? 'success' : 'warning'}`}>{item?.status}</span>
                            </div>
                            <div className="date_info"><span>Date</span>{moment(item.createdAt).format('DD-MM-YYYY  hh:ss A')}</div>
                          </div>
                        </td>
                        <td>Network <span>{item?.chain || item?.chainId || 'Internal transfer'}</span></td>
                        <td>
                          Address
                          <div className="address_icon">
                            <span>{shortAddress || '----'}</span>
                            {shortAddress && <span onClick={() => copytext(item?.to_address)}><CopyIcon /></span>}
                          </div>
                        </td>
                        <td>
                          TxID
                          <div className="address_icon">
                            <span>{shortTxHash || '----'}</span>
                            {shortTxHash && <span onClick={() => copytext(item?.transaction_hash)}><CopyIcon /></span>}
                          </div>
                        </td>
                        <td onClick={() => handleWithdrawModal(item)}>View</td>
                      </tr>
                    );
                  }) : noDataRow}
                </tbody>
              </table>
            </div>
          </div>

          <div className="withdraw_history_mobile">
            {filteredHistory?.length > 0 ? (
              <div className="withdraw_cards_list">
                {filteredHistory.map((item) => {
                  const shortAddress = shortenAddress(item?.to_address);
                  const shortTxHash = shortenAddress(item?.transaction_hash);
                  const filteredImageData = allCoinData?.filter((data) => data?.short_name === item?.short_name)[0] || [];
                  return (
                    <div key={item?._id || item?.createdAt} className="withdraw_card_item">
                      <div className="withdraw_card_header">
                        <div className="withdraw_card_title">
                          <img width="32" height="32" src={Object.keys(filteredImageData).length > 0 ? ApiConfig.baseImage + filteredImageData.icon_path : ''} alt="" />
                          <span className="withdraw_amount">{item?.amount} {item?.currency}</span>
                          <span className={`withdraw_status text-${item?.status === 'REJECTED' ? 'danger' : item?.status === 'COMPLETED' ? 'success' : 'warning'}`}>{item?.status}</span>
                        </div>
                        <div className="withdraw_card_date">
                          <span className="label">Date</span> {moment(item.createdAt).format('DD-MM-YYYY  hh:ss A')}
                        </div>
                      </div>
                      <div className="withdraw_card_row">
                        <span className="label">Network</span>
                        <span>{item?.chain || item?.chainId || 'Internal transfer'}</span>
                      </div>
                      <div className="withdraw_card_row address_icon">
                        <span className="label">Address</span>
                        <span className="value">{shortAddress || '----'}{shortAddress && <span onClick={() => copytext(item?.to_address)} aria-label="Copy"><CopyIcon /></span>}</span>
                      </div>
                      <div className="withdraw_card_row address_icon">
                        <span className="label">TxID</span>
                        <span className="value">{shortTxHash || '----'}</span>
                        {shortTxHash && <span onClick={() => copytext(item?.transaction_hash)} aria-label="Copy"><CopyIcon /></span>}
                      </div>
                      <div className="withdraw_card_footer">
                        <button type="button" className="withdraw_card_view_btn" onClick={() => handleWithdrawModal(item)}>View</button>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="no-data-wrapper">
                <div className="no_data_vector">
                  <img src="/images/no_data_vector.svg" className="img-fluid dark_img" width="96" height="96" alt="No data" />
                  <img src="/images/no_data_vector_light.png" className="img-fluid light_img" alt="No data" />
                </div>
              </div>
            )}
          </div>

          {filteredHistory?.length > 0 && (
            <div className="hVPalX gap-2 mt-3">
              <span>
                {totalDataLength === 0 ? 0 : (currentPage - 1) * limit + 1}-{Math.min(currentPage * limit, totalDataLength)} of {totalDataLength}
              </span>
              <div className="sc-eAKtBH gVtWSU">
                <button type="button" aria-label="First Page" className="sc-gjLLEI kuPCgf" onClick={() => handlePagination('first')}>
                  <i className="ri-skip-back-fill text-white"></i>
                </button>
                <button type="button" aria-label="Previous Page" className="sc-gjLLEI kuPCgf" onClick={() => handlePagination('prev')}>
                  <i className="ri-arrow-left-s-line text-white"></i>
                </button>
                <button type="button" aria-label="Next Page" className="sc-gjLLEI kuPCgf" onClick={() => handlePagination('next')}>
                  <i className="ri-arrow-right-s-line text-white"></i>
                </button>
                <button type="button" aria-label="Last Page" className="sc-gjLLEI kuPCgf" onClick={() => handlePagination('last')}>
                  <i className="ri-skip-forward-fill text-white"></i>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="modal fade search_form table_pop_up search_form_modal_2" id="recent_table" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Withdrawal Details</h2>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="withdrawal_top_list">
                <div className="bn_step_content">
                  <h5>Withdrawal order submitted</h5>
                  <span>{moment(modalData.createdAt).format('DD-MM-YYYY  hh:ss A')}</span>
                </div>
                <div className="bn_step_content">
                  <h5>System processing</h5>
                  <span>{moment(modalData.createdAt).format('DD-MM-YYYY  hh:ss A')}</span>
                </div>
                <div className="bn_step_content">
                  <h5 className={modalData?.status === 'PENDING' && 'withdrawal_pending'}>{modalData?.status}</h5>
                  <span>{moment(modalData.updatedAt).format('DD-MM-YYYY  hh:ss A')}</span>
                </div>
              </div>
              <div className="hot_trading_t">
                <table>
                  <tbody>
                    <tr>
                      <td>Status</td>
                      <td className="right_t price_tb">
                        {modalData?.status === 'REJECTED' ? <span className="red">{modalData?.status}</span> : modalData?.status === 'COMPLETED' ? <span className="green">{modalData?.status}</span> : <span className="yellow">{modalData?.status}</span>}
                      </td>
                    </tr>
                    <tr>
                      <td>Coin</td>
                      <td className="right_t price_tb">{modalData?.short_name}</td>
                    </tr>
                    <tr>
                      <td>Withdraw amount</td>
                      <td className="right_t price_tb">{modalData?.amount}</td>
                    </tr>
                    <tr>
                      <td>Network</td>
                      <td className="right_t price_tb">{modalData?.chain}</td>
                    </tr>
                    <tr>
                      <td>Address</td>
                      <td className="right_t price_tb">
                        <div className="address_icon">
                          <span>{modalData?.shortToAddress || '----'}</span>
                          <svg className="bn-svg icon-small-pointer" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={() => copytext(modalData?.to_address)}>
                            <path fillRule="evenodd" clipRule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor"></path>
                          </svg>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>TxID</td>
                      <td className="right_t price_tb">
                        <div className="address_icon">
                          <span>{modalData?.shortTxHash?.trim() || '----'}</span>
                          <svg className="bn-svg icon-small-pointer" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" onClick={() => copytext(modalData?.transaction_hash)}>
                            <path fillRule="evenodd" clipRule="evenodd" d="M9 3h11v13h-3V6H9V3zM4 8v13h11V8.02L4 8z" fill="currentColor"></path>
                          </svg>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawHistory;
